module.exports = __webpack_public_path__ + "static/img/vod-bn-8.d31f0d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vod-bn-8.jpg
// module id = RGfF
// module chunks = 1